// Constants for activity tracking and auto-logout
export const IDLE_TIME_THROTTLE = 3600; // 1 hour (in seconds)
export const SA_IDLE_TIME_THROTTLE = 86400; // 24 hours for super admins (in seconds)
export const MODAL_GRACE_PERIOD = 30; // 30 seconds to respond to modal
